// extracted by mini-css-extract-plugin
export default {"wrapper":"Yu-z","response":"Zu-z","error":"_u-z","disabled":"av-z","buttons":"bv-z","feedbackQuestionSection":"cv-z","yesNoWrapper":"dv-z"};